import { render } from "./USDTPaymentPage.vue?vue&type=template&id=30433228&scoped=true"
import script from "./USDTPaymentPage.vue?vue&type=script&lang=js"
export * from "./USDTPaymentPage.vue?vue&type=script&lang=js"

import "./USDTPaymentPage.vue?vue&type=style&index=0&id=30433228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30433228"]])

export default __exports__